import React from 'react';

import { Typography } from '@mui/material';
import { AlineLogoIcon } from 'src/components/icons/AlineLogoIcon';
import { makeStyles } from 'tss-react/mui';

/**
 * Note the styles here are meant to mirror those for the loading state in index.html.
 * Change both styles in lock-step if any changes are made.
 */
export const useAppLoadingStyles = makeStyles()(theme => ({
  container: {
    alignItems: 'center',
    backgroundColor: theme.palette.common.white,
    display: 'flex',
    flexDirection: 'column',
    gap: theme.spacing(2),
    height: '100vh',
    justifyContent: 'center',
    width: '100%',
  },
  loadingText: {
    fontSize: 14,
    textAlign: 'center',
  },
  logo: {
    height: 120,
    width: 120,
  },
}));

interface AppLoadingProps {
  waitingText: string;
}

export function AppLoading({ waitingText }: AppLoadingProps): JSX.Element {
  const { classes } = useAppLoadingStyles();

  return (
    <div className={classes.container}>
      <AlineLogoIcon className={classes.logo} />
      <Typography className={classes.loadingText}>{waitingText}</Typography>
    </div>
  );
}
